import { render } from "./OqituvchiIshi.vue?vue&type=template&id=4e684375&scoped=true"
import script from "./OqituvchiIshi.vue?vue&type=script&lang=js"
export * from "./OqituvchiIshi.vue?vue&type=script&lang=js"

import "./OqituvchiIshi.vue?vue&type=style&index=0&id=4e684375&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e684375"]])

export default __exports__